export const getTemperatureInFahrenheit = (temperatureInCelsius: any) => {
  return (Number(temperatureInCelsius) * (9 / 5) + 32).toFixed(2);
}
